import {
  mdiArrowTopRight,
  mdiHistory,
  mdiPlus,
  mdiFilterVariant,
} from "@mdi/js";
import Icon from "@mdi/react";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import EntityHistory, {
  GetMasterLogsByEntityApi,
} from "../../purchase_order/purchase_order_create/components/entity_logs";
import { useHistory } from "react-router-dom";
import { urls } from "../../../utils/urls";
import {
  defaultKazamGSTFilter,
  KazamGST,
  KazamGSTFilter,
} from "../models/gst_model";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";
import { GSTGetRepo } from "./repo/gst_repo";
import LoadingWidget from "../../../context_providers/modal/loader";
import FilterDropDown from "../../../ui/new_components/common/filter_drop_down";
import { ACTION, indianStates, MODULE } from "../../../utils/enums";
import { useAuth } from "../../../context_providers/auth/authProvider";
import moment from "moment";
import { AttachmentModel } from "../../purchase_order/model/purchase_order_model";
import {
  ModalAlignment,
  ModalType,
} from "../../../context_providers/modal/modal_context";
import DrawerWidget from "../../../context_providers/modal/drawer_widget";
import GSTAttachmentModalSection from "./components/gst_attachment_modal";
import SearchFieldWidget from "../../../ui/new_components/search_field";
import { toQueryString } from "../../../service/api_client";
import Pagination from "../../../ui/new_components/common/pagination";
import {
  ResponsiveListShell,
  FilterSheet,
  DateRangeFilter,
  MobileRecordCard,
  MobileRecordCardList,
  EmptyState,
} from "../../../ui/new_components/common/responsive";

const GstListScreen = () => {
  const navigation = useHistory();
  const { isAuthorised } = useAuth();
  const [maker, setMaker] = useState(false);
  const [selectedItem, setSelectedItem] = useState<KazamGST | null>(null);
  const { showToast } = useToast();

  useEffect(() => {
    const authorised = isAuthorised({
      action: [ACTION.UPDATE, ACTION.CREATE, ACTION.READ],
      module: MODULE.kazam_gst,
      operator: "and",
    });
    setMaker(authorised);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [loading, setLoading] = useState(false);
  const [showAttachment, setShowAttachment] = useState<KazamGST>();
  const [showHistory, setShowHistory] = useState<string>();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<KazamGST[]>([]);
  const [filter, setFilter] = useState<KazamGSTFilter>(defaultKazamGSTFilter);
  const [showFilter, setShowFilter] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 768,
  );

  const handleCheckboxChange = (item: KazamGST) => {
    setSelectedItem((prev) => (prev?.id === item.id ? null : item));
  };

  const handleDetailScreen = (item: KazamGST) => {
    navigation.push(urls.procurement_masters_gst + "/detail-screen/" + item.id);
  };

  const GSTListData = async () => {
    try {
      const a = document.createElement("a");
      a.target = "_blank";
      a.href = `${
        process.env.REACT_APP_BACKEND_BASE_URL
      }/api/v3/erp/gst/export${toQueryString({
        query: JSON.stringify({
          ...filter,
        }),
      })}`;

      // Delay the trigger to allow UI updates (if necessary)
      setTimeout(() => {
        setLoading(false);
        showToast({ type: ToastType.success, text: "Download started!" });
        a.click(); // Trigger the download
      }, 1000);
    } catch (error) {
      setLoading(false); // Make sure loading is set to false in case of an error
      showToast({ type: ToastType.error, text: "Failed to start download." });
      console.error("Download error:", error);
    }
  };

  const onSelect = () => {
    if (!selectedItem) {
      showToast({
        type: ToastType.error,
        text: "Please select one item to edit",
      });
    } else {
      navigation.push(
        urls.procurement_masters_gst + "/update/" + selectedItem!.id,
      );
    }
  };

  const fetchData = async (prop: KazamGSTFilter) => {
    setLoading(true);
    try {
      const res = await GSTGetRepo(prop);
      if (res.success) {
        setData(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const debouncedHandler = useCallback(
    debounce((prop: KazamGSTFilter) => {
      if (prop) fetchData(prop);
    }, 500),
    [],
  );

  useEffect(() => {
    debouncedHandler(filter);
  }, [page, filter, debouncedHandler]);

  const onSelectAttchment = (d: AttachmentModel) => {
    window.open(d.url, "_blank");
  };

  return (
    <>
      {showHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="GST History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetMasterLogsByEntityApi({
                entityType: "kazam gst",
                entityId: showHistory,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}
      {showAttachment && (
        <DrawerWidget
          data={{
            id: 1,
            title: "Attachments",
            type: ModalType.drawer,
            alignment: ModalAlignment.right,
            container: (
              <GSTAttachmentModalSection
                // key={attachmentKey}
                attachments={showAttachment.attachments}
                onSubmit={() => {}}
                onDelete={() => {}}
                onSelect={onSelectAttchment}
              />
            ),
          }}
          onClose={function (): void {
            setShowAttachment(undefined);
          }}
        ></DrawerWidget>
      )}
      <ResponsiveListShell
        title="Kazam GST"
        count={total}
        onRefresh={() => fetchData(filter)}
        search={
          <div id="gst_number_search">
            <SearchFieldWidget
              placeholder="GST Number"
              defaulValue={filter?.gst_number}
              onClear={() => {
                setFilter({ ...filter, gst_number: " " });
                setPage(1);
              }}
              onSubmit={(val) => {
                setFilter({ ...filter, gst_number: val });
                setPage(1);
              }}
            />
          </div>
        }
        actions={
          <>
            <button
              id="export_btn"
              onClick={() => {
                GSTListData();
              }}
              className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
            >
              <Icon path={mdiArrowTopRight} className="h-4 w-4"></Icon>Export
            </button>
            {maker && (
              <button
                id="create_btn"
                onClick={() => {
                  navigation.push(urls.procurement_masters_gst + "/create");
                }}
                className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
              >
                <Icon path={mdiPlus} className="h-4 w-4"></Icon>Create
              </button>
            )}
            {maker && (
              <button
                id="update_btn"
                onClick={onSelect}
                className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-white transform text-xs"
              >
                <Icon path={mdiPlus} className="h-4 w-4"></Icon>Update
              </button>
            )}
          </>
        }
        filterToggle={
          <div className="flex gap-2 items-center">
            <h6 className="font-normal text-xs">Filters</h6>
            <div
              id="gst_list_filter_toggle_btn"
              onClick={() => setShowFilter((v) => !v)}
              className="flex items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white cursor-pointer"
            >
              <Icon path={mdiFilterVariant} className="w-4 h-4" />
            </div>
          </div>
        }
      >
        <FilterSheet
          show={showFilter}
          onClose={() => setShowFilter(false)}
          onApply={() => setShowFilter(false)}
          onReset={() => setFilter(defaultKazamGSTFilter)}
          gridClassName="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-2 items-start"
        >
          <div id="gst_created_at_filter">
            <label>Created At</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromDate={
                filter.from ? moment(filter?.from).format("YYYY-MM-DD") : ""
              }
              toDate={filter.to ? moment(filter?.to).format("YYYY-MM-DD") : ""}
              onFromChange={(v) =>
                setFilter({
                  ...filter,
                  from: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
              onToChange={(v) =>
                setFilter({
                  ...filter,
                  to: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
            />
          </div>
          <div id="name_search">
            <label className="text-sm font-semibold mb-1">Name</label>
            <SearchFieldWidget
              defaulValue={filter?.name}
              onClear={() => {
                setFilter({ ...filter, name: " " });
                setPage(1);
              }}
              onSubmit={(val) => {
                setFilter({ ...filter, name: val });
                setPage(1);
              }}
            />
          </div>
          <div id="state_filter">
            <label className="text-sm font-semibold mb-1">Select State</label>
            <FilterDropDown
              placeholder="Select State"
              onClearAll={() => setFilter({ ...filter, state: [] })}
              onDelete={(state) => {
                setFilter({
                  ...filter,
                  state: filter.state?.filter((val) => val !== state),
                });
              }}
              onSelect={(state) => {
                setFilter({
                  ...filter,
                  state: [...(filter.state ?? []), state],
                });
              }}
              selectedOptions={filter.state}
              options={indianStates.map((t) => ({
                label: t,
                value: t,
              }))}
            />
          </div>
        </FilterSheet>

        {data.length > 0 ? (
          <>
            <div className="hidden md:block my-2 border">
              <div className="overflow-auto">
                <table
                  id="gst_list_table"
                  className="w-full text-xs divide-y divide-gray-200 relative"
                >
                  <thead className="text-xs py-2 bg-white z-10">
                    <tr className="border">
                      <th className="px-2 py-2">Select</th>
                      <th className="px-2 py-2 text-center">History</th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        GST Number
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Name
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Created At
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        State
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Address Line1
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Address Line2
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Address Line3
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        City
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        State
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Country
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Pincode
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Efffective Date of Registration
                      </th>
                      <th className="px-3 py-3 whitespace-nowrap text-left">
                        Attachments
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, i) => {
                      const isSelected = selectedItem === item;

                      return (
                        <tr
                          key={i}
                          id={`gst_row_${item.id}`}
                          className="border text-center"
                        >
                          <td>
                            <div className="p-2">
                              <input
                                id={`gst_select_${item.id}`}
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleCheckboxChange(item)}
                              />
                            </div>
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-center">
                            <div
                              id={`gst_history_${item.id}`}
                              className="cursor-pointer flex justify-center"
                              title="History"
                              onClick={() => setShowHistory(item.id)}
                            >
                              <Icon path={mdiHistory} size="16"></Icon>
                            </div>
                          </td>

                          <td
                            id={`gst_detail_link_${item.id}`}
                            className="px-3 py-3 whitespace-nowrap text-left cursor-pointer text-blue-600 hover:underline"
                            onClick={() => handleDetailScreen(item)}
                          >
                            {item.gst_number ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.name ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {moment(item.created_at).format("DD-MM-YYYY") ??
                              "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.state ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.line1 ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.line2 ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.line3 ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.city ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.state ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.country ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            {item.address?.pincode ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-center">
                            {moment(item.effective_date_of_reg).format(
                              "DD/MM/YYYY",
                            ) ?? "--"}
                          </td>
                          <td className="px-3 py-3 whitespace-nowrap text-left">
                            <button
                              id={`gst_view_attachment_${item.id}`}
                              onClick={() => setShowAttachment(item)}
                              className="text-sm font-semibold text-blue-400 hover:text-blue-500 flex items-center gap-1 px-2 h-full w-full"
                            >
                              View
                              <div>({item?.attachments?.length})</div>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <MobileRecordCardList>
              {data.map((item, i) => (
                <MobileRecordCard
                  id={`gst_row_mobile_${item.id}`}
                  key={i}
                  onClick={() => handleDetailScreen(item)}
                  title={item.gst_number ?? "-"}
                  fields={[
                    { label: "Name", value: item.name ?? "-" },
                    { label: "State", value: item.address?.state ?? "-" },
                    { label: "City", value: item.address?.city ?? "-" },
                    {
                      label: "Created At",
                      value: moment(item.created_at).format("DD-MM-YYYY"),
                    },
                    {
                      label: "Attachments",
                      value: item?.attachments?.length ?? 0,
                    },
                  ]}
                  actions={[
                    {
                      icon: mdiHistory,
                      title: "History",
                      onClick: () => setShowHistory(item.id),
                    },
                  ]}
                />
              ))}
            </MobileRecordCardList>

            <div
              id="gst_list_pagination"
              className="mt-3 sticky bottom-0 bg-white z-10 border-t flex justify-between items-center px-4 py-2"
            >
              <Pagination
                itemCount={data.length}
                page={page}
                total={total}
                count={filter.count}
                onChange={setPage}
              />
            </div>
          </>
        ) : !loading ? (
          <EmptyState
            title="No GST records found!"
            message="Try adjusting your search or filters."
            imageSrc="/images/nodata.png"
          />
        ) : null}
      </ResponsiveListShell>

      {loading && <LoadingWidget />}
    </>
  );
};

export default GstListScreen;
